/* eslint-disable */
import * as Types from '../../../models/schema';

import { MainGrapeFragmentDTO } from '../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateMainGrapeVariablesDTO = Types.Exact<{
  data: Types.MainGrapeCreateInputDTO;
}>;


export type CreateMainGrapeDTO = (
  { __typename?: 'Mutation' }
  & { createOneMainGrape: (
    { __typename?: 'MainGrape' }
    & MainGrapeFragmentDTO
  ) }
);


export const CreateMainGrapeDocumentDTO = gql`
    mutation createMainGrape($data: MainGrapeCreateInput!) {
  createOneMainGrape(data: $data) {
    ...mainGrapeFragment
  }
}
    ${MainGrapeFragmentDTO}`;
export type CreateMainGrapeMutationFnDTO = Apollo.MutationFunction<CreateMainGrapeDTO, CreateMainGrapeVariablesDTO>;

/**
 * __useCreateMainGrape__
 *
 * To run a mutation, you first call `useCreateMainGrape` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMainGrape` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMainGrape, { data, loading, error }] = useCreateMainGrape({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMainGrape(baseOptions?: Apollo.MutationHookOptions<CreateMainGrapeDTO, CreateMainGrapeVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMainGrapeDTO, CreateMainGrapeVariablesDTO>(CreateMainGrapeDocumentDTO, options);
      }
export type CreateMainGrapeHookResult = ReturnType<typeof useCreateMainGrape>;
export type CreateMainGrapeMutationResultDTO = Apollo.MutationResult<CreateMainGrapeDTO>;
export type CreateMainGrapeMutationOptionsDTO = Apollo.BaseMutationOptions<CreateMainGrapeDTO, CreateMainGrapeVariablesDTO>;